import _ from 'lodash';

const parser = value => (value === 'null' ? '' : value);

const nullParser = string => _.map(string.split(' '), x => parser(x)).join(' ');

export default nullParser;
